import { IAddressBase } from '../../models/address';
import jhsfBookingsApi from '../apis/jhsfBookingsApi';
import { IDetailedBooking } from './ShowBookingsService';

export interface IBookingPayment {
  address?: IAddressBase;
  acquirerName?: string;
  acquirerNsu?: string;
  authorizationCode?: string;
  authorizedAt?: Date;
  brand?: string;
  userFiscalRecipient: boolean;
  installments?: number;
  type?: 'CREDIT_CARD' | 'DEBIT_CARD' | 'PIX' | 'CASH';
}

interface ICreateBookingExternalPaymentsService {
  bookingId: string;
  payment?: IBookingPayment;
}

export type IBookingExternalPayment = IDetailedBooking;

export const createBookingExternalPaymentsService = async ({
  bookingId,
  payment,
}: ICreateBookingExternalPaymentsService): Promise<IBookingExternalPayment> => {
  const { data } = await jhsfBookingsApi.post<IBookingExternalPayment>(
    `/bookings/${bookingId}/external-payments`,
    { payment },
  );

  return data;
};
